import moment from 'moment-timezone';
import _ from 'lodash';

export const TASK_VALIDATION_MODES = {
  DRAFT: 'draft',
  LAUNCH: 'launch',
};

export const TITLE_MAX_LENGTH = 255;

export function validateTask(task, mode, now = moment()) {
  const isLaunch = mode === TASK_VALIDATION_MODES.LAUNCH;
  /** @type {{
   * content_requests: Object<string, {title?: string, media_type?: string}>,
   * content_requests_summary?: string,
   * description?: string,
   * due_date?: string,
   * title?: string
   * }} */
  const errors = {
    content_requests: validateContentRequests(task.content_requests),
  };

  if (!hasValue(task.title)) {
    errors.title = 'Title is required.';
  }

  if (isLaunch && !hasValue(task.description)) {
    errors.description = 'Description is required to post this request.';
  }

  if (task.due_date && !moment(task.due_date).isValid()) {
    errors.due_date = 'Enter a valid deadline.';
  } else if (task.due_date && deadlineHasPassed(task.due_date, now)) {
    errors.due_date = isLaunch
      ? 'This deadline has already passed. Choose a new deadline to post this request.'
      : 'Deadline cannot be in the past.';
  } else if (isLaunch && !task.due_date) {
    errors.due_date = 'Deadline is required to post this request.';
  }

  if (isLaunch && !task.content_requests?.length) {
    errors.content_requests_summary = 'Add at least one content item.';
  } else if (!_.isEmpty(errors.content_requests)) {
    errors.content_requests_summary = isLaunch
      ? 'Complete each content item before posting this request.'
      : 'Complete each content item, or remove to save as draft.';
  }

  const isValid =
    !errors.title &&
    !errors.description &&
    !errors.due_date &&
    !errors.content_requests_summary &&
    _.isEmpty(errors.content_requests);

  return { errors, isValid };
}

/**
 * Keys content item errors by ui_id rather than position so an error stays with
 * its item when the admin reorders or removes rows. Items without problems are
 * left out, which lets callers read an empty object as "every item is valid".
 */
function validateContentRequests(contentRequests) {
  const contentRequestErrors = _.mapValues(
    _.keyBy(contentRequests, 'ui_id'),
    (contentRequest) => ({
      ...(!hasValue(contentRequest.title)
        ? { title: 'Content item title is required.' }
        : {}),
      ...(!hasValue(contentRequest.media_type)
        ? { media_type: 'Select a media type.' }
        : {}),
    })
  );

  return _.omitBy(contentRequestErrors, _.isEmpty);
}

/**
 *Comparing in America/Chicago rather than the browser's local zone
 * keeps this in sync with how the deadline is stored
 */
function deadlineHasPassed(dueDate, now) {
  return moment(dueDate)
    .tz('America/Chicago')
    .isBefore(moment(now).tz('America/Chicago'), 'day');
}

function hasValue(value) {
  return typeof value === 'string' ? Boolean(value.trim()) : Boolean(value);
}
